import { getQueryMethod, resources, entities, methods, getURLParams } from '../utils';
const { meloAPI } = resources;
const { charges } = entities;
const { POST, PATCH, GET } = methods;

const query = getQueryMethod(meloAPI, charges);

const endpoints = {
  createCharge: async body => {
    return await query('', POST, body);
  },
  getChargesPaginated: async ({ businessId, ...params }) => {
    const queryParams = getURLParams(params);
    return await query(`get-many/${businessId}?${queryParams}`);
  },
  generateCharge: async body => {
    return await query('generate-charge', PATCH, body);
  },
  getChargePaymentReceipt: async purchaseId => {
    return await query(`${purchaseId}/payment-receipt`, GET);
  },
  getChargeVoucher: async purchaseId => {
    return await query(`${purchaseId}/voucher`, GET);
  }
};

export default endpoints;
